<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  app-modal-cancelar-retificacao(
    v-if="showModalRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setor'
    @closeModal="closeRetificacao"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL",
    @refresh="refresh"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-modal-selecionar-modelo-extrato-sentenca(
    :titulo="'Extrato de sentença'",
    :showModal="showModalModeloDespacho"
    @closeModal="fecharModalModeloDespacho",
    :processosSelecionados="processosSelecionados"
  )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    :infoPrazos="infoPrazos"
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false",
    @selectItem="selecionarProcessos"
  )
  el-row(v-if="isEstadoBA()").row-style
    el-button(
      :disabled="!processosSelecionados.length"
      type="success",
      @click="criarExtratoSentenca()",
      size="small"
    )
      b Criar Extrato de Sentença
</template>

<script>
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalSelecionarModeloExtratoSentenca from '../components/AppModalSelecionarModeloExtratoSentenca.vue'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import { mapActions } from 'vuex'
const { filtro, selectItem } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalTrocarResponsavel,
    AppModalSelecionarModeloExtratoSentenca,
    AppModalCancelarRetificacao
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('PUBLICACAO'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      numeroProcesso: null,
      showModalRetificacao: false,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      idsProcessosAssinatura: [],
      showModalVisualizarProcesso: false,
      showModalModeloDespacho: false,
      mensagem: '',
      infoProcessosSelecionados: [],
      configuracaoFiltro: {
        filtroResponsavel: filtro?.filtroResponsavel?.PUBLICACAO || [],
        filtroCpf: filtro?.filtroCpf?.PUBLICACAO || [],
        filtroDataChegada: filtro?.filtroDataChegada?.PUBLICACAO || [],
        filtroCadastrante: filtro?.filtroCadastrante?.PUBLICACAO || [],
        filtroMunicipio: filtro?.filtroMunicipio?.PUBLICACAO || [],
        filtroSituacao: filtro?.filtroSituacao?.PUBLICACAO || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt', marcado: () => this.isEstadoBA() },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [], exibir: () => this.showColuna('filtroCpf') },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 9, titulo: 'Situação', propriedade: 'status', ordem: 1, acoes: [], exibir: () => this.showColuna('filtroSituacao') },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [], exibir: () => this.showColuna('filtroMunicipio') },
        { id: 8, titulo: 'Executor', propriedade: 'nomeCadastrante', sortable: true, ordem: 3, acoes: [], exibir: () => this.showColuna('filtroCadastrante') },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [], exibir: () => this.showColuna('filtroDataChegada') },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: this.isEstadoBA() ? 'Analista' : 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [] },
        { id: 6, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 7, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Acusar Publicação', icone: 'fa-check', codigo: 'PUBLICAR_OU_ACUSAR_PORTARIA', ordem: 1, show: this.showAcusarPublicacao },
            { id: 3, nome: 'Publicar portaria', icone: 'fa-file-export', codigo: 'PUBLICAR_OU_ACUSAR_PORTARIA', ordem: 2, show: this.showPublicarPortaria },
            { id: 4, nome: 'Vincular Responsável', icone: 'fa-user-plus', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showVincularAnalista },
            { id: 5, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showTrocarResponsavel },
            { id: 6, nome: 'Continuar Publicação', icone: 'fa-file-export', codigo: 'PUBLICAR_OU_ACUSAR_PORTARIA', ordem: 2, show: this.showContinuarPublicarPortaria, showToltip: this.showToltipRetificacao, textToltip: this.textToltip },
            { id: 7, nome: 'Publicar Termo de Retificação', icone: 'fa-file-export', codigo: 'PUBLICAR_OU_ACUSAR_PORTARIA', ordem: 2, show: this.showPublicarTermoRetificacao },
            { id: 8, nome: 'Cancelar Retificação', icone: 'fa-times', codigo: 'CANCELAR_RETIFICACAO', ordem: 1, show: this.showCancelarRetificacaoProcessso }

          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  methods: {
    ...mapActions({
      processosJaCadastrados: 'despacho/processosJaCadastrados'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    async PUBLICAR_OU_ACUSAR_PORTARIA (_this, { item }) {
      if (_this.isTramitarPublicacaoPortaria(item)) {
        await _this.executarTramitacao(item.id)
      }

      _this.$router.push({
        name: 'analise/analisar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    CADASTRAR_PUBLICACAO: async (_this, { item }) => {
      _this.$router.push({
        name: 'analise/analisar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    TROCAR_ANALISTA: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    showColuna (coluna) {
      return (
        this.configuracaoFiltro[coluna].find(
          perfil => perfil === this.usuario?.perfilSelecionado?.codigo
        ) !== undefined
      )
    },
    isEstadoBA () {
      return process.env.ESTADO === 'ba'
    },
    criarExtratoSentenca () {
      this.showModalModeloDespacho = true
    },
    fecharModalModeloDespacho () {
      this.refresh()
      this.showModalModeloDespacho = false
    },
    selecionarProcessos (item) {
      selectItem(item, this.processosSelecionados)
      if (!this.infoProcessosSelecionados.length) {
        this.infoProcessosSelecionados.push(item)
      } else {
        const index = this.infoProcessosSelecionados.findIndex(p => p.id === item.id)
        if (index === -1) {
          this.infoProcessosSelecionados.push(item)
        } else {
          this.infoProcessosSelecionados.splice(index, 1)
        }
      }
    },
    CANCELAR_RETIFICACAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.setor = item.setor
      this.showModalRetificacao = true
    },
    closeRetificacao (item) {
      this.showModalRetificacao = false
      this.refresh()
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
.row-style {
  display: flex;
  justify-content: end;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaPublicacaoListagem.vue